import React from "react";
import {Box, Button, Card, CardContent, Grid, ListItem, Typography} from "@deere/fuel-react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { FormatTextOutput } from "../shared/styles/FormatTextOutput";

export const HomeAnnouncement = ({ title, announcements, editable, handleAnnouncementEdit, handleAnnouncementDelete, handleCreateInternalAnnouncement, handleCreateExternalAnnouncement }) => {

    if (!Array.isArray(announcements)) {
        return null;
    }

    const formatTimeStamp = (timestamp) => {
        const date = new Date(timestamp);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
    };

    return (
        <Card>
            <CardContent>
                <Grid container>
                    <Grid item xs={6}>
                        <Typography variant="h4" style={{ marginBottom: "1rem" }}>{title}</Typography>
                    </Grid>
                    {announcements.map((announcement) => (
                        <ListItem divider style={{ padding: 0, marginBottom: ".5rem" }} key={announcement.id}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant={"body1"}>
                                        <FormatTextOutput text={announcement.announcement} />
                                    </Typography>
                                </Grid>
                                <Grid item xs={editable ? 10 : 12}>
                                    <Box display="flex" justifyContent="flex-end" pt={1} pb={1}>
                                        <Typography size="sm" color="tertiary">
                                            {formatTimeStamp(announcement.timestamp)}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            {editable && (
                                <>
                                    <Grid item xs={1}>
                                        <IconButton onClick={() => handleAnnouncementEdit(announcement.id)} aria-label="edit">
                                            <EditIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton onClick={() => handleAnnouncementDelete(announcement.id)} aria-label="delete">
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                </>
                            )}
                        </ListItem>
                    ))}
                    {editable && handleCreateInternalAnnouncement &&(
                        <Button onClick={() => handleCreateInternalAnnouncement()}>
                            Add New Internal Announcement
                        </Button>
                    )}
                    {editable && handleCreateExternalAnnouncement &&(
                        <Button onClick={() => handleCreateExternalAnnouncement()}>
                            Add New External Announcement
                        </Button>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
}